import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { clearUser } from "../redux/auth/auth.slice";
import Home from "../views/home/home.view";

function PrivateRoute({ children, isPublic }) {
	const userToken = useSelector((state) => state.currentUser?.token);

	const userIsAllowed = isPublic || Boolean(userToken);

	if (!userIsAllowed) {
		return <Navigate to="/introduction" replace={true} />;
	}

	return children;
}

PrivateRoute.defaultProps = {
	children: "موردی برای نمایش وجود ندارد.",
	restrictedRoles: null,
};

export default PrivateRoute;
